import { render, staticRenderFns } from "./prepaidsettle.vue?vue&type=template&id=4dd5d5c6&"
import script from "./prepaidsettle.vue?vue&type=script&lang=js&"
export * from "./prepaidsettle.vue?vue&type=script&lang=js&"
import style0 from "./prepaidsettle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports